import { Box } from '@mui/material'
import { Col, Row } from 'antd'
import React, { useState } from 'react'
import { BiBuildings, BiCategory } from 'react-icons/bi'
import { ImTree } from 'react-icons/im'
import { TbChartDots3 } from 'react-icons/tb'
import { useNavigate } from 'react-router-dom'
import AddDomainModal from '../../../reusable-component/AddDomainModal'
import AddEngagementModal from '../../../reusable-component/AddEngagementModal'
import AddWorkflowModal from '../../../reusable-component/AddWorkflowModal'

function QuickActions() {
    const navigate = useNavigate();
    const [openDomainModal, setOpenDomainModal] = useState(false);
    const [openClientModal, setOpenClientModal] = useState(false);
    const [openEngagementModal, setOpenEngagementModal] = useState(false);
    const [openWorkflowModal, setOpenWorkflowModal] = useState(false);

    const quickActions = [
        {
            icon: <BiCategory />,
            title: 'Create New Domain',
            description: 'Set up a new business domain',
            color: '#fff',
            backgroundColor: '#20639B',
            onClick: () => {
                setOpenDomainModal(true);
            }
        }, {
            icon: <BiBuildings />,
            title: 'Add New Client',
            description: 'Register a new client organization',
            color: '#fff',
            backgroundColor: '#2A8BB0',
            onClick: () => {
                setOpenClientModal(true);
                navigate('/client/onboarding');
            }
        }, {
            icon: <ImTree />,
            title: 'Start Engagement',
            description: 'Initiate a new client engagement',
            color: '#fff',
            backgroundColor: '#3CAEA3',
            onClick: () => {
                setOpenEngagementModal(true);
            }
        }, {
            icon: <TbChartDots3 />,
            title: 'Build Workflow',
            description: 'Create a new data workflow',
            color: '#fff',
            backgroundColor: '#5CC8B8',
            onClick: () => {
                setOpenWorkflowModal(true);
            }
        },

    ]

    const QuickActionItem = ({ icon, title, description, color, backgroundColor, onClick }) => (
        <Box
            onClick={onClick}
            style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 12,
                background: backgroundColor,
                padding: '15px 15px',
                borderRadius: 5,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.opacity = '0.9';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.opacity = '1';
            }}
        >
            {React.cloneElement(icon, { style: { color: '#fff', fontSize: 30, flexShrink: 0, marginTop: 2 } })}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flex: 1 }}>
                <span style={{ color, fontSize: 16, fontWeight: 600, lineHeight: 1.2 }}>{title}</span>
                <span style={{ color, fontSize: 12, fontWeight: 400, opacity: 0.9, lineHeight: 1.3 }}>{description}</span>
            </div>
        </Box>
    )

    return (
        <div>
            <Row gutter={[16, 16]}>
                {quickActions.map((action, index) => (
                    <Col xs={24} sm={12} md={12} lg={6} xl={6} key={index}>
                        <QuickActionItem key={action.title} {...action} />
                    </Col>
                ))}
            </Row>

            {openDomainModal && <AddDomainModal openModal={openDomainModal} handleCloseModal={() => setOpenDomainModal(false)} fetchData={() => { }} />}
            {/* {openClientModal && <AddClientModal openModal={openClientModal} handleCloseModal={() => setOpenClientModal(false)} fetchData={() => { }} />} */}
            {openEngagementModal && <AddEngagementModal openModal={openEngagementModal} handleCloseModal={() => setOpenEngagementModal(false)} fetchData={() => { }} />}
            {openWorkflowModal && <AddWorkflowModal open={openWorkflowModal} handleModal={() => setOpenWorkflowModal(false)} fetchTableData={() => { }} processType="Data Transformation" />}
        </div>
    )
}

export default QuickActions